document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.hkt--mp__group').forEach(group => {
    const maxQty = parseInt(group.dataset.hktGroupLimit) || 7;
    const allSelectors = group.querySelectorAll('.hkt--mp__qty-selector');

    // Function to calculate total quantity in this group
    function getTotalQty() {
      let total = 0;
      allSelectors.forEach(selector => {
        const input = selector.querySelector('.hkt--mp__input');
        total += parseInt(input.value) || 0;
      });
      return total;
    }

    // Function to update all buttons and inputs in the group
    function updateAllControls() {
      const currentTotal = getTotalQty();

      allSelectors.forEach(selector => {
        const minusBtn = selector.querySelector('.hkt--mp__minus');
        const plusBtn = selector.querySelector('.hkt--mp__plus');
        const input = selector.querySelector('.hkt--mp__input');
        const cardDiv = selector.closest('.hkt--mp__card');
        const hiddenInput = cardDiv.querySelector('.hkt--mp__hidden');
        const productTitle = cardDiv.dataset.hktCardTitle || 'Product';

        const currentQty = parseInt(input.value) || 0;

        // Update hidden input
        if (currentQty > 0) {
          hiddenInput.name = `properties[${productTitle}]`;
          hiddenInput.value = `x${currentQty}`;
        } else {
          hiddenInput.removeAttribute('name');
          hiddenInput.value = '';
        }

        // Minus button: only disabled if quantity is 0
        minusBtn.disabled = currentQty <= 0;

        // Plus button: disabled ONLY if limit is reached AND this item has 0 quantity
        // If item already has quantity, user can still adjust (decrease other items to increase this)
        const limitReached = currentTotal >= maxQty;
        
        if (currentQty > 0) {
          // If this item has quantity, plus is only disabled if we're at limit
          plusBtn.disabled = limitReached;
        } else {
          // If this item has 0 quantity, plus is disabled when limit is reached
          plusBtn.disabled = limitReached;
        }

        // Visual feedback: only dim cards with 0 quantity when limit is reached
        if (limitReached && currentQty === 0) {
          cardDiv.classList.add('limit-reached');
        } else {
          cardDiv.classList.remove('limit-reached');
        }
      });

      // Update group counter
      updateGroupCounter(group, currentTotal, maxQty);
    }

    // Optional: Show total counter
    function updateGroupCounter(group, current, max) {
      let counter = group.querySelector('.hkt--mp__counter');
      if (!counter) {
        counter = document.createElement('div');
        counter.className = 'hkt--mp__counter';
        const title = group.querySelector('.hkt--mp__group-title');
        if (title) {
          title.insertAdjacentElement('afterend', counter);
        }
      }
      counter.textContent = `Selected: ${current} / ${max}`;
      
      // Single color, but bold when limit reached
      counter.style.color = '#bf5239';
      counter.style.fontWeight = current >= max ? 'bold' : '500';
    }

    // Initialize all selectors
    allSelectors.forEach(selector => {
      const minusBtn = selector.querySelector('.hkt--mp__minus');
      const plusBtn = selector.querySelector('.hkt--mp__plus');
      const input = selector.querySelector('.hkt--mp__input');

      // Minus button click
      minusBtn.addEventListener('click', () => {
        let val = parseInt(input.value) || 0;
        if (val > 0) {
          input.value = val - 1;
          updateAllControls();
        }
      });

      // Plus button click
      plusBtn.addEventListener('click', () => {
        const currentTotal = getTotalQty();
        let val = parseInt(input.value) || 0;
        
        // Only allow increase if total hasn't reached limit
        if (currentTotal < maxQty) {
          input.value = val + 1;
          updateAllControls();
        }
      });

      // Manual input change
      input.addEventListener('input', () => {
        let val = parseInt(input.value) || 0;
        const currentItemOldValue = parseInt(input.dataset.oldValue) || 0;
        const otherTotal = getTotalQty() - currentItemOldValue; // Total without this input's old value
        
        // Ensure this input doesn't exceed remaining quota
        const maxAllowed = maxQty - otherTotal;
        if (val > maxAllowed) {
          input.value = maxAllowed;
        }
        if (val < 0) {
          input.value = 0;
        }
        
        // Store current value for next change
        input.dataset.oldValue = input.value;
        
        updateAllControls();
      });

      // Initialize old value
      input.dataset.oldValue = input.value;
    });

    // Initial update
    updateAllControls();
  });
});